import { render, staticRenderFns } from "./HisInformationItemTypeSelector.vue?vue&type=template&id=369dbe52&"
import script from "./HisInformationItemTypeSelector.vue?vue&type=script&lang=ts&"
export * from "./HisInformationItemTypeSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports